export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "%0": "",
        "1K tokenów": "",
        "1M tokenów": "",
        "Aby połączenie z API OpenAI zostało nawiązane, należy podać klucz wygenerowany na stronie producenta i wybrać wersję modelu. Połączenie z API jest sprawdzane przy zapisie formularza.": "",
        "Aby przejść do następnego kroku, użyj przycisku \"Następny krok\".": "",
        "Adres API": "",
        "Aktywuj AI": "",
        "Aktywuj Asystenta AI": "",
        "Aktywuj czat AI": "",
        "Aktywuj funkcjonalności AI": "",
        "Aktywuj inteligentne usługi oparte o sztuczną inteligencję.": "",
        "Aktywuj inteligentnego asystenta opartego o sztuczną inteligencję.": "",
        "Aktywuj możliwości narzędzi OpenAI.": "",
        "Aktywuj OpenAI": "",
        "Asystent": "",
        "Asystent AI": "",
        "Asystent został pomyślnie utworzony.": "",
        "Asystent został pomyślnie zainicjalizowany.": "",
        "Azure OpenAI": "",
        "Brak danych do wyświetlenia": "",
        "Brak kategorii": "",
        "Brak materiałów": "",
        "Brak ograniczenia": "",
        "Cennik Azure OpenAI": "",
        "Cennik OpenAI": "",
        "Choices": "",
        "Created": "",
        "Czat AI": "",
        "DALL-E 3": "",
        "DALLE-3": "",
        "Dane wejściowe": "",
        "Dane wyjściowe": "",
        "Dodaj lekcję": "",
        "Dodaj model": "",
        "Dodaj test": "",
        "Domyślny": "",
        "Dostawca": "",
        "Dostawca jest wymagany": "",
        "Embedding": "",
        "Etykieta": "",
        "Funkcjonalności AI": "",
        "Generator dynamicznych formularzy włączony": "",
        "Generator dynamicznych formularzy wyłączony": "",
        "Generator metadanych obrazu włączony": "",
        "Generator metadanych obrazu wyłączony": "",
        "Generator metadanych SEO włączony": "",
        "Generator metadanych SEO wyłączony": "",
        "Generator obrazów włączony": "",
        "Generator obrazów wyłączony": "",
        "Generowanie planu szkolenia rozpoczęte": "",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut.": "",
        "Generuj plan kursu": "",
        "Generuj szkolenie": "",
        "GPT-4 Turbo": "",
        "GPT-4o": "",
        "GPT-4o mini": "",
        "GPT-4o Mini": "",
        "Historia": "",
        "Id": "",
        "Id dokumentu nadrzędnego Outline": "",
        "Id slajdu": "",
        "Identity": "",
        "Identyfikator odpowiedzi.": "",
        "Identyfikator slajdu": "",
        "Identyfikator zapytania": "",
        "Inteligentne narzędzie generujące dynamiczne formularze.": "",
        "Inteligentne narzędzie generujące metadane obrazu.": "",
        "Inteligentne narzędzie generujące metadane SEO.": "",
        "Inteligentne narzędzie generujące obrazy.": "",
        "Inteligentne narzędzie wskazujące najbardziej trafny wynik wyszukiwania.": "",
        "Inteligentny czas posiadający wiedzę na tematu systemu Edito.": "",
        "Jakość HD": "",
        "Jakość standardowa": "",
        "Kategoria szkolenia": "",
        "Klucz API": "",
        "Klucz Azure Open AI API": "",
        "Klucz Outline API": "",
        "Konfiguracja AI": "",
        "Konfiguracja Asystenta AI nieprawidłowa": "",
        "Konfiguracja Asystenta AI prawidłowa": "",
        "Krok 1": "",
        "Krok 2": "",
        "Krok 3": "",
        "Label musi mieć co najmniej 3 znaki": "",
        "Label nie może być dłuższy niż 100 znaków": "",
        "Lekcja": "",
        "Limit API": "",
        "Limit jest potrzebny do poprawnego wyświetlenia statystyk zużycia na stronie głównej panelu. Nie jest powiązany z limitem konta.": "",
        "Link": "",
        "Lista możliwości zakończenia czatu. W obecnym stanie model zwraca jedną możliwą odpowiedź.": "",
        "Lista wiadomości (prompt) składających się na dotychczasową konwersację z modelem.": "",
        "Maksymalna liczba tokenów": "",
        "Max tokens": "",
        "Messages": "",
        "Model": "",
        "Model generuje odpowiedź na podstawie podanych przez użytkownika parametrów.": "",
        "Moderacja włączona": "",
        "Moderacja wyłączona": "",
        "Moderacjia danych wejściowych jest zalecana.": "",
        "Mowa": "",
        "Na podstawie dołączonych plików oraz zaproponowanego planu zostanie utworzone szkolenie.": "",
        "Na podstawie dołączonych plików zostanie zaproponowany plan szkolenia.": "",
        "Narzędzia AI": "",
        "Następny krok": "",
        "Nazwa": "",
        "Nazwa musi mieć co najmniej 2 znaki": "",
        "Nazwa nie może być dłuższa niż 50 znaków": "",
        "Nazwa pliku": "",
        "Nazwa szkolenia": "",
        "Nazwa wdrożenia chatu": "",
        "Nazwa wdrożenia embeddingów": "",
        "Nie udało się pobrać kategorii.": "",
        "Nie udało się pobrać lub przygotować asystenta. Próba utworzenia nowego asystenta...": "",
        "Nie udało się powiązać plików z asystentem AI.": "",
        "Nie udało się utworzyć asystenta.": "",
        "Nie udało się utworzyć i zainicjalizować asystenta.": "",
        "Nie udało się utworzyć szkolenia.": "",
        "Nie udało się wygenerować planu kursu.": "",
        "Nie udało się zacząć generowania planu.": "",
        "Niepoprawny format wygenrowanego planu szkolenia": "",
        "NOWOŚĆ": "",
        "Object": "",
        "Obrazy": "",
        "Odpowiedź": "",
        "Ograniczna wygenerowaną odpowiedź do podanej liczby tokenów.": "",
        "OpenAI": "",
        "OpenAI o1": "",
        "OpenAI o1-mini": "",
        "Parameters": "",
        "Parametry": "",
        "Plan kursu został wygenerowany.": "",
        "Plik został pomyślnie przesłany do asystenta AI.": "",
        "Pliki zostały pomyślnie powiązane z asystentem AI.": "",
        "Pliki zostały przetworzone": "",
        "Po zaznaczeniu opcji, plan szkolenia zostanie wygenerowany na podstawie dołączonych plików.": "",
        "Podaj nazwę szkolenia.": "",
        "Podaj symbol strony szkolenia.": "",
        "Połączenie z API OpenAI jest aktywne.": "",
        "Połączenie z API OpenAI jest nieaktywne.": "",
        "Potwierdzenie usunięcia": "",
        "Powrót": "",
        "Proszę czekać, trwa generowanie planu szkoleń.": "",
        "Proszę czekać, trwa inicjalizacja asystenta AI.": "",
        "Prywatny klucz Langfuse": "",
        "Przekroczono czas oczekiwania na dane asystenta.": "",
        "Przepisz aktualne stawki za milion tokenów z cennika Azure OpenAI.": "",
        "Przepisz aktualne stawki za milion tokenów z cennika OpenAI.": "",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika Azure OpenAI.": "",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika OpenAI.": "",
        "Przetestuj": "",
        "PRZYKŁADOWY PROMPT": "",
        "Publiczny klucz Langfuse": "",
        "Rozdzielczość obrazu: 1024x1024": "",
        "Rozdzielczość obrazu: 1024x1792 lub 1792x1024": "",
        "Scorm": "",
        "Status": "",
        "Statystyki wykorzystania tokenów.": "",
        "Stwórz": "",
        "Suma zużytych tokenów": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol strony szkolenia": "",
        "Synchronizuj": "",
        "Szczegóły zapytania OpenAI": "",
        "Szkolenie zostało wygenerowane.": "",
        "Tekst": "",
        "Temat": "",
        "Test": "",
        "Test konfiguracji przeszedł pomyślnie": "",
        "Test konfiguracji przeszedł z ostrzeżeniami": "",
        "Test konfiguracji zakończył się niepowodzeniem": "",
        "Test ustawień": "",
        "Test ustawień pomyślnie zakończony.": "",
        "Tokeny łącznie": "",
        "Tokeny odpowiedzi": "",
        "Tokeny zapytania": "",
        "Trwa generowanie planu szkolenia, może to potrwać kilka minut.": "",
        "Trwa testowanie konfiguracji...": "",
        "tutaj": "",
        "Typ": "",
        "Typ danych": "",
        "Typ musi być jedną z dozwolonych wartości": "",
        "Typ obiektu.": "",
        "Uniksowy znacznik czasu utworzenia zakończenia czatu.": "",
        "URL zasobu Azure AI": "",
        "Usage": "",
        "Ustawienia": "",
        "Ustawienia Asystenta AI zostały zapisane.": "",
        "Ustawienia chatu zostały zapisane.": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń model": "",
        "Usuń plik": "",
        "Uzupelnij dane kursu, aby zaproponować plan szkolenia.": "",
        "Uzupełnij stronę publikacji i język.": "",
        "Uzupełnij wytyczne dla Kreatora szkoleń.": "",
        "Video": "",
        "Wersja": "",
        "Wersja API": "",
        "Wersja jest wymagana": "",
        "Wersja modelu": "",
        "Wersja modelu GPT.": "",
        "Wersja nie może być dłuższa niż 20 znaków": "",
        "Wizja": "",
        "Właściciel": "",
        "Właściciel musi mieć co najmniej 2 znaki": "",
        "Właściciel nie może być dłuższy niż 50 znaków": "",
        "Właściwości": "",
        "wybierz": "",
        "Wybierz dostępne pliki": "",
        "Wybierz kategorię szkolenia.": "",
        "wybierz model": "",
        "Wybierz nowe pliki z komputera": "",
        "Wybierz przynajmniej jeden plik z bazy wiedzy lub dodaj plik z komputera.": "",
        "Wybierz stronę nadrzędną szkolenia.": "",
        "wybierz wersję": "",
        "Wyczyść wszystkie": "",
        "Wygenerowane szkolenie znajdziesz ": "",
        "Wygeneruj plan szkolenia zanim przejdziesz dalej.": "",
        "Wyszukiwarka włączona": "",
        "Wyszukiwarka wyłączona": "",
        "Wytyczne dla Kreatora szkoleń": "",
        "Z komputera": "",
        "Zaktualizowano model asystenta do bieżącej konfiguracji AI.": "",
        "Zapisz": "",
        "Zapytanie": "",
        "Zobacz szczegóły": "",
        "Zużyte tokeny": ""
    }
};
